import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import cssImage from '../../assets/image/css-bg.png';
import spaImage from '../../assets/image/SPA.png';
import snippetImage from '../../assets/image/Snippet.png';
import './Landing.css';
const Landing = () => {
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      {/* <img src={logoImage} className="logo-pic" /> */}
      <div className="carve-section" style={{ textAlign: 'center', overflow: 'auto', flex: '1', display: 'flex', flexFlow: 'column' }}>
        <div className="outer-chamber">
          <div className="title-chamber">
            <div className="title">start carving your app</div>
          </div>
        </div>
        <div className="d-flex x-center g-4" style={{ flex: '1', alignItems: 'center', marginTop: '8rem', marginBottom: '8rem' }}>
          <div className="cursor-pointer w-same">
            <Link to='/home' aria-label="Go to Home">
              <div className="section-chamber">
                <img src={cssImage} alt="img" />
              </div>
              <div className="section-title">
                <h2 className="d-block carve-text-middle">CSS Library</h2>
                <h6>a lightweight, customisable CSS framework</h6>
              </div>
            </Link>
          </div>
          <div className="cursor-pointer w-same">
            <Link to='/spa' aria-label="Go to SPA">
              <div className="section-chamber">
                <img src={spaImage} alt="img" />
              </div>
              <div className="section-title">
                <h2 className="d-block carve-text-middle">SPA Library</h2>
                <h6>you can set up a basic single page application. </h6>
              </div>
            </Link>
          </div>
          <div className="cursor-pointer w-same">
            <Link to='/snippet' aria-label="Go to Snippet">
              <div className="section-chamber">
                <img src={snippetImage} alt="img" />
              </div>
              <div className="section-title">
                <h2 className="d-block carve-text-middle">Code Snippets</h2>
                <h6>Code Snippets</h6>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Landing;